import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'

@Component({
    selector: 'app-tutorial',
    templateUrl: './tutorial.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class TutorialComponent implements OnInit {

    en = {}
    showEN = true
    active = false

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }
}



// WEBPACK FOOTER //
// ./src/app/promotion/tutorial/tutorial.component.ts